// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__m7Ue5","headingText":"Heading_headingText__JwOuR","headingAccessories":"Heading_headingAccessories__5k6py"};